import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Footer } from '../components/landing/Footer';
import { motion } from 'framer-motion';
import { Head } from '../components/Head';
import { LocalizedLink } from '../components/LocalizedLink';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50 dark:bg-neutral-900">
      <Head
        metas={[
          {
            name: 'robots',
            content: 'noindex, nofollow'
          }
        ]}
      />
      
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-6xl font-bold text-primary-600 mb-4">404</h1>
            <h2 className="text-2xl font-medium text-gray-800 dark:text-gray-200 mb-6">
              {t('notFound.title')}
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8">
              {t('notFound.message')}
            </p>
            
            <LocalizedLink 
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-300"
            >
              {t('notFound.backHome')}
            </LocalizedLink>
          </motion.div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
